export default function getCircuitName(circuit) {
    return circuit ? `${circuit.name}, ${circuit.country}` : "";
}
